// components/StatsAndFilters.js
import React from 'react';
import {
  Box, Paper, Typography, FormControl,
  InputLabel, MenuItem, Select, Card, CardContent, Chip
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import SchoolIcon from '@mui/icons-material/School';
import BusinessIcon from '@mui/icons-material/Business';

const StatsAndFilters = ({
  reportCount,
  userTypeFilter,
  institutionFilter,
  setUserTypeFilter,
  setInstitutionFilter,
  rows
}) => {
  return (
    <Box sx={{ mb: 3 }}>
      {/* Filters Section */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" fontWeight="bold" color="primary" gutterBottom sx={{ mb: 2, fontSize: { xs: '1rem', sm: '1.125rem' } }}>
          Filters
        </Typography>
        <Box sx={{ 
          display: 'flex', 
          gap: { xs: 2, sm: 3 }, 
          flexWrap: 'wrap',
          flexDirection: { xs: 'column', sm: 'row' }
        }}>
          <FormControl sx={{ minWidth: { xs: '100%', sm: 200 } }}>
            <InputLabel>User Type</InputLabel>
            <Select
              value={userTypeFilter}
              label="User Type"
              onChange={(e) => setUserTypeFilter(e.target.value)}
              size="small"
            >
              <MenuItem value="">All Types</MenuItem>
              <MenuItem value="SCHOOL">School</MenuItem>
              <MenuItem value="COLLEGE">College</MenuItem>
              <MenuItem value="PROFESSIONAL">Professional</MenuItem>
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: { xs: '100%', sm: 200 } }}>
            <InputLabel>Institution</InputLabel>
            <Select
              value={institutionFilter}
              label="Institution"
              onChange={(e) => setInstitutionFilter(e.target.value)}
              size="small"
            >
              <MenuItem value="">All Institutions</MenuItem>
              {Array.from(new Set(rows?.map(user => user.INSTITUTION_NAME).filter(Boolean))).map((institution) => (
                <MenuItem key={institution} value={institution}>
                  {institution}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>
    </Box>
  );
};

export default StatsAndFilters;
